import Mutation from './mutation';

const IGNORE_REGION_SIZE = 100;

// const GENES = "5UTR,ORF1a,ORF1b,S,ORF3a,E,M,ORF6,ORF7a,ORF7b,ORF8,N,ORF9b,ORF10,3UTR,Non-coding region".split(",");


const POSITIONS = {
  "5UTR" :  {"start": 0,     "end": 265,   "aa": 89,   "saa": 0,    "eaa": 87, "untranslating" : true},
  "ORF1a":  {"start": 266,   "end": 13442, "aa": 4392, "saa": 88,   "eaa": 4480},
  "ORF1b":  {"start": 13444, "end": 21555, "aa": 2704, "saa": 4481, "eaa": 7184},
  "S":      {"start": 21563, "end": 25384, "aa": 1274, "saa": 7187, "eaa": 8461},
  "ORF3a":  {"start": 25393, "end": 26220, "aa": 276,  "saa": 8463, "eaa": 8739},
  "E":      {"start": 26245, "end": 26472, "aa": 76,   "saa": 8747, "eaa": 8823},
  "M":      {"start": 26523, "end": 27191, "aa": 223,  "saa": 8840, "eaa": 9063},
  "ORF6":   {"start": 27202, "end": 27387, "aa": 62,   "saa": 9066, "eaa": 9128},
  "ORF7a":  {"start": 27394, "end": 27759, "aa": 122,  "saa": 9130, "eaa": 9252},
  "ORF7b":  {"start": 27756, "end": 27887, "aa": 44,   "saa": 9251, "eaa": 9295},
  "ORF8":   {"start": 27894, "end": 28259, "aa": 122,  "saa": 9297, "eaa": 9419},
  "N":      {"start": 28274, "end": 29533, "aa": 420,  "saa": 9424, "eaa": 9844},
  // "ORF9b":  {"start": 28284, "end": 28577, "aa": 98,   "saa": 9427, "eaa": 9525, "overlapping" : true},
  "ORF10":  {"start": 29558, "end": 29674, "aa": 39,   "saa": 9852, "eaa": 9891},
  "3UTR":   {"start": 29675, "end": 29677, "aa": 1,    "saa": 9892, "eaa": 9893, "untranslating" : true},
  "Non-coding region" : {"start": 29676, "end": 29811, "aa": 135,    "saa": 9894, "eaa": 9937, "untranslating" : true},
};


let getFileSequences = fileText=>{
  let lines = fileText.split('\n'),
    sequences = [],
    s = {sequence: ''};
  lines.forEach(line=>{
    if (line[0] === ">") {
      if (s.sequence.length > 0) {
        sequences.push(s);
        s = {sequence: ''};
      }
      s.name = line.substring(1);
    } else {
      s.sequence += line;
    }
  });
  if (s.sequence.length > 0) {
    sequences.push(s);
  }
  return sequences;
};


let regroup = (s, mutations)=>{
  s.mutations = mutations;
  s.unsequencedRegions = flagUnsequencedRegions(s.sequence);
  s.byRegion = groupByGene(mutations);
  return s;
};


let flagUnsequencedRegions = sequence=>{
  let ignores = [],
    dashStart = 0;
  for (let i = 0; i <sequence.length; i++) {
    if (sequence[i] === '-') {
      if (dashStart === -1) {
        dashStart = i;
      }
    } else if (dashStart >= 0) {
      let missingLength = i - dashStart;
      if (missingLength >= IGNORE_REGION_SIZE || (i>0 && dashStart === 0)) {
        console.log('unseqd', missingLength, dashStart, i)
        ignores.push([dashStart, i - 1]);
      }
      dashStart = -1;
    }
  }
  if (dashStart >= 0) {
    ignores.push([dashStart, sequence.length - 1]);
  }
  console.log(ignores);
  return ignores;
}


let groupByGene = mutationList=>{
  let byRegion = {};
  mutationList.forEach(m=>{
    let mut = new Mutation(m);
    byRegion[mut.gene] = mut;
  })
  return byRegion;
};

// let ref = null;
// fetch('./assets/data/sarscov2-ref.fa').then(r=>r.text()).then(text=>ref = getFileSequences(text)[0]);



export { POSITIONS, regroup, getFileSequences };